import { EditEventModalProps } from './EditEventModal';
import { openModal } from '@core/components/ModalStack';

export async function openEditEventModal(props: EditEventModalProps) {
  const { EditEventModal } = await import('./EditEventModal');

  openModal(EditEventModal, props);
}
